// extracted by mini-css-extract-plugin
module.exports = {"container":"fullClickableWithInvisibleElement_container__hB2Qt","invisibleElement":"fullClickableWithInvisibleElement_invisibleElement__au6h8"};